import { useRef, useCallback } from 'react'
import { apiPost } from 'helpers/generalHelper'

// Custom hook for managing reader version updates
export const useReaderVersion = (orderId: string | number, currentReaderVersion?: string) => {
  const appInfoRef = useRef<{ appVersion: string; ldrVersion: string; uuid: string } | null>(null)
  
  const clearAppInfo = useCallback(() => {
    appInfoRef.current = null
  }, [])
  
  const storeAppInfo = useCallback((appInfo: { appVersion: string; ldrVersion: string; uuid: string }) => {
    if (!appInfoRef.current) {
      appInfoRef.current = appInfo
    }
  }, [])
  
  const updateReaderVersion = useCallback(async () => {
    if (orderId && appInfoRef.current && currentReaderVersion !== appInfoRef.current.appVersion) {
      try {
        await apiPost(`/dme/orders/${orderId}/reader-version`, {
          readerVersion: appInfoRef.current.appVersion
        })
        console.log('Reader version was set after upload')
      } catch (error) {
        console.error('Failed to set reader version after upload:', error)
      }
      clearAppInfo()
    }
  }, [orderId, currentReaderVersion, clearAppInfo])
  
  return { storeAppInfo, updateReaderVersion, clearAppInfo }
}
